import { useState } from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { SidebarLayout } from '../components/layout/SidebarLayout';
import { PageHeader } from '../components/layout/PageHeader';
import { SavedViewsList } from '../components/layout/SavedViewsList';
import { PackageSearch, Activity, FileText, Settings, Filter, Plus } from 'lucide-react';

const STATIC_MARKETS = Array.from({ length: 50 }).map((_, i) => ({
  id: `M-${2026}-${1000 + i}`,
  title: `Fourniture et installation d'équipements lot ${i + 1}`,
  date: '2026-06-01',
  amount: Math.floor(Math.random() * 5000000) + 100000,
  status: i % 3 === 0 ? 'Clôturé' : 'En cours'
}));

export function LayoutTestPage() {
  const [activeTab, setActiveTab] = useState('explorer');
  const [activeView, setActiveView] = useState('v1');

  const sidebarContent = (
    <>
      <div className="flex flex-col gap-1">
        <button
          onClick={() => setActiveTab('explorer')}
          className={`flex items-center px-3 py-2 text-sm rounded-md transition-colors ${activeTab === 'explorer' ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 font-medium' : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-slate-100'}`}
        >
          <PackageSearch size={16} className="mr-3" /> Explorer
        </button>
        <button
          onClick={() => setActiveTab('suivi')}
          className={`flex items-center px-3 py-2 text-sm rounded-md transition-colors ${activeTab === 'suivi' ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 font-medium' : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-slate-100'}`}
        >
          <Activity size={16} className="mr-3" /> Suivi
        </button>
        <button
          onClick={() => setActiveTab('documents')}
          className={`flex items-center px-3 py-2 text-sm rounded-md transition-colors ${activeTab === 'documents' ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 font-medium' : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-slate-100'}`}
        >
          <FileText size={16} className="mr-3" /> Documents cachés
        </button>
        <button
          onClick={() => setActiveTab('settings')}
          className={`flex items-center px-3 py-2 text-sm rounded-md transition-colors ${activeTab === 'settings' ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 font-medium' : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-slate-100'}`}
        >
          <Settings size={16} className="mr-3" /> Paramètres
        </button>
      </div>

      <hr className="border-slate-200 dark:border-slate-700" />

      {activeTab === 'explorer' && (
        <SavedViewsList
          views={[
            { id: 'v1', name: 'Tous les marchés actifs' },
            { id: 'v2', name: 'Pompage' },
            { id: 'v3', name: 'Station de pompage (Nord)' },
            { id: 'v4', name: 'Travaux de voirie' },
            { id: 'v5', name: 'Appels d\'offres limités' }
          ]}
          activeViewId={activeView}
          onSelect={setActiveView}
          onAddView={() => alert('Add view')}
        />
      )}
    </>
  );

  const mainContent = (
    <div className="flex flex-col h-full bg-white dark:bg-gray-900 relative">
      <PageHeader
        breadcrumbs={[
          { label: 'Tableau de bord', href: '#' },
          { label: 'Marchés publics', href: '#' },
          { label: 'Explorer' }
        ]}
        actions={
          <>
            <button className="md:px-3 px-2 py-1.5 text-sm border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-200 rounded-md hover:bg-slate-50 dark:hover:bg-slate-800 flex items-center justify-center">
              <Filter size={16} className="md:mr-2" />
              <span className="hidden md:inline">Filtrer</span>
            </button>
            <button className="md:px-3 px-2 py-1.5 text-sm bg-primary-600 text-white rounded-md hover:bg-primary-700 font-medium flex items-center justify-center">
              <Plus size={16} className="md:mr-2" />
              <span className="hidden md:inline">Nouveau projet</span>
            </button>
          </>
        }
      />
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl font-semibold mb-4 font-[Söhne,sans-serif]">Données (Simulation de scroll)</h2>
          <p className="text-slate-500 mb-6 text-sm">
            Faites défiler cette zone. Ni le header global, ni la sidebar ne devraient bouger.
          </p>

          <div className="border border-slate-200 dark:border-gray-700 rounded-md shadow-sm overflow-x-auto bg-white dark:bg-gray-800">
            <table className="min-w-full divide-y divide-slate-200 dark:divide-gray-700 whitespace-nowrap">
              <thead className="bg-slate-50 dark:bg-gray-900/50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 dark:text-gray-400 uppercase">Référence</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 dark:text-gray-400 uppercase">Titre</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 dark:text-gray-400 uppercase">Montant</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-slate-500 dark:text-gray-400 uppercase">Statut</th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-slate-200 dark:divide-gray-700">
                {STATIC_MARKETS.map(row => (
                  <tr key={row.id} className="hover:bg-slate-50 dark:hover:bg-gray-700/50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900 dark:text-gray-100">{row.id}</td>
                    <td className="px-6 py-4 text-sm text-slate-500 dark:text-gray-300">{row.title}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500 dark:text-gray-300 text-right">
                      {new Intl.NumberFormat('fr-MA', { style: 'currency', currency: 'MAD' }).format(row.amount)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${row.status === 'Clôturé' ? 'bg-slate-100 dark:bg-gray-700 text-slate-800 dark:text-gray-200' : 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400'}`}>
                        {row.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <AppLayout>
      <SidebarLayout
        sidebarContent={sidebarContent}
        mainContent={mainContent}
      />
    </AppLayout>
  );
}
